import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import {PickUpDto } from './pickup.dto';


export class AllPickUpResponseModel extends GlobalResponseObject{
    data?:PickUpDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?:PickUpDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}